 
import React from "react";
 
const DashboardView = React.lazy(() =>import("../Pages/Home/Home"));
const MySlotView = React.lazy(() =>import("../Pages/Home/MySlot.jsx"));
const SlotAddView = React.lazy(() =>import("../Pages/Home/AddSlot.jsx"));
const SlotEditView = React.lazy(() =>import("../Pages/Home/EditSlot.jsx"));
const BlockSlotes = React.lazy(() =>import("../Pages/Home/BlockSlotes/BlockSlotes.jsx"));
const AppointmentsView = React.lazy(() =>import("../Pages/Appointments/Appointments"));
const AddWalkInPatients = React.lazy(() =>import("../Pages/Appointments/Queue/AddWalkinPatient.jsx"));
const AppointmentsViewDetails = React.lazy(() =>import("../Pages/Appointments/ListAppointments/ViewAppointment.jsx"));
const AddAppointmentsView = React.lazy(() =>import("../Pages/Appointments/BookAppointments/ViewBookAppointment.jsx"));
const EditAppointmentsView = React.lazy(() =>import("../Pages/Appointments/EditAppointments"));
const HistoryView = React.lazy(() =>import("../Pages/Appointments/History/HistoryView"));
const TestLogView = React.lazy(() =>import("../Pages/Appointments/History/Log/TestLog"));
const MedicineLogView = React.lazy(() =>import("../Pages/Appointments/History/Log/MedicineLog"));
const AddLabTestView = React.lazy(() =>import("../Pages/Appointments/Add/AddLabTest"));
const AddMedicineView = React.lazy(() =>import("../Pages/Appointments/Add/AddMedicine"));
const AppointmentRequestView = React.lazy(() =>import("../Pages/Appointments/Request/AppointmentRequest.jsx"));
const EditAppointmentRequestView = React.lazy(() =>import("../Pages/Appointments/Request/EditAppointmentRequest.jsx"));
const AnalyticsView = React.lazy(()=>import ("../Pages/Analytics/AnalyticsDashboard.jsx"));
const SlotSetupView = React.lazy(()=>import("../Pages/SlotSetup/SlotSetup.jsx"));
const AddSlotView = React.lazy(()=>import("../Pages/SlotSetup/AddSlot/AddSlot.jsx"));
const ProfileView = React.lazy(() =>import("../Pages/Profile/Profile"));

const Patient = React.lazy(() =>import("../Pages/Patient/Patients.jsx"));
const ViewPatient = React.lazy(() =>import("../Pages/Patient/ViewPatient.jsx"));
const ConsultationSummary = React.lazy(() =>import("../Pages/Patient/ConsultaionSummary.jsx"));
const AddPatientAppointmentsView = React.lazy(() =>import("../Pages/Patient/AddPatientAppoinment.jsx"));
const PatientEditAppointmentsView = React.lazy(() =>import("../Pages/Patient/PatientEditAppoinments.jsx"));
const PatientHistoryView = React.lazy(() =>import("../Pages/Patient/History/PatientHistoryView.jsx"));
const PatientTestLogView = React.lazy(() =>import("../Pages/Patient/History/Log/PatientTestLog.jsx"));
const PatientMedicineLogView = React.lazy(() =>import("../Pages/Patient/History/Log/PatientMedicineLog.jsx"));
const PatientAddLabTestView = React.lazy(() =>import("../Pages/Patient/Add/PatientAddLabTest.jsx"));
const PatientAddMedicineView = React.lazy(() =>import("../Pages/Patient/Add/PatientAddMedicine.jsx"));
const PatientAppointmentRequestView = React.lazy(() =>import("../Pages/Patient/PatientRequest/PatientAppoinmentRequest.jsx"));
const PatientEditAppointmentRequestView = React.lazy(() =>import("../Pages/Patient/PatientRequest/PatientEditAppoinmentRequest.jsx"));


const ConsultationView = React.lazy(() => import("../Pages/Consultation/Consultation.jsx"));
const FollowUpView = React.lazy(() => import("../Pages/FollowUp/FollowUp.jsx"));
const PatientEngagementView = React.lazy(() => import("../Pages/Patient Engagement/PatientEngagement.jsx"));
const PatientNotificationForm = React.lazy(() => import("../Pages/Patient Engagement/CreateNotification.jsx"));
const SubscriptionManagementView = React.lazy(() => import("../Pages/SubscriptionManagement/SubscriptionManagement.jsx"));
const SubscriptionSuccessView = React.lazy(() => import("../Pages/SubscriptionManagement/SubscriptionSuccess .jsx"));
const BillingProfileView = React.lazy(() =>
  import("../Pages/SubscriptionManagement/BillingProfile.jsx")
);

const EditBillingProfileView = React.lazy(() =>
  import("../Pages/SubscriptionManagement/EditBillingProfile.jsx")
);
const SubscriptionBillingView = React.lazy(() =>
  import("../Pages/SubscriptionManagement/SubscriptionBilling.jsx")
);

const AdminRoutes = [
      { path: "/", name: "Home", Element: DashboardView },
    { path: "/my-slots", name: "My Slots", Element:MySlotView  },
    { path: "/my-slots/add-new-slots", name: "Add Slots", Element:SlotAddView  },
    { path: "/my-slots/edit-slot/:slotId", name: "Edit Slots", Element:SlotEditView  },
    { path: "/my-slots/block-dates", name: "Block Slotes", Element:BlockSlotes  },
    { path: "/appointments",name: "Appointments", Element: AppointmentsView},
    { path: "/appointments/add",name: "BookAppointment", Element: AddAppointmentsView},
    { path: "/appointments/add-walk-in-patient",name: "Add Walk In Patients", Element: AddWalkInPatients},
    { path: "/appointments/view-details/:id",name: "Appointments View", Element: AppointmentsViewDetails},
    { path: "/appointments/addappointments",name: "Add Appointments", Element: AddAppointmentsView},
    { path: "/appointments/updateappointments",name: "Update Appointments", Element: EditAppointmentsView},
    { path: "/appointments/history",name: "History", Element: HistoryView},
    { path: "/appointments/history/testlog",name: "Test Log", Element: TestLogView},
    { path: "/appointments/history/medicinelog",name: "Medicine Log", Element: MedicineLogView},
    { path: "/appointments/addtest",name: "Add Test", Element: AddLabTestView},
    { path: "/appointments/addmedicine",name: "Add Medicine", Element: AddMedicineView},
    { path: "/appointments/request",name: "Request", Element: AppointmentRequestView},
    { path: "/appointments/editrequest",name: "Edit Request", Element: EditAppointmentRequestView},
    { path: "/analytics", name:"Analytics", Element:AnalyticsView},
    { path: "/slotsetup",name: "SlotSetup", Element: SlotSetupView},
    { path: "/slotsetup/addslot",name: "AddSlotSetup", Element: AddSlotView},
    { path: "/profile",name: "Profile", Element: ProfileView},

    { path: "/patients",name: "patients", Element:Patient},
    { path: "/patients/view/:id",name: "ViewPatient", Element:ViewPatient},
    { path: "/patients/consultation/:id",name: "ConsultationSummary", Element:ConsultationSummary},
    { path: "/patients/addpatientappoinments",name: "AddAppointment", Element: AddPatientAppointmentsView},
    { path: "/patients/updatepatientappoinments",name: "EditAppointment", Element: PatientEditAppointmentsView},
    { path: "/patient/patienthistory",name: "History", Element: PatientHistoryView},
    { path: "/patient/history/patienttestlog",name: "TestLog", Element: PatientTestLogView},
    { path: "/patient/history/patientmedicinelog",name: "MedicineLog", Element: PatientMedicineLogView},
    { path: "/patient/patientaddtest",name: "AddTest", Element: PatientAddLabTestView},
    { path: "/patient/patientaddmedicine",name: "AddMedicine", Element: PatientAddMedicineView},
    { path: "/patient/patientrequest",name: "Request", Element: PatientAppointmentRequestView},
    { path: "/patient/patienteditrequest",name: "EditRequest", Element: PatientEditAppointmentRequestView},

    { path: "/consultations/:id",name: "Consultation", Element: ConsultationView},

    { path: "/follow-up/",name: "FollowUp", Element: FollowUpView},
    { path: "/patient-engagement",name: "Patient Engagement", Element: PatientEngagementView},
    {path: "/patient-engagement/create",name: "Create Notification", Element: PatientNotificationForm,},
    { path: "/patient-engagement/edit/:id", name: "Edit Notification",Element: PatientNotificationForm,},
    { path: "/patient-engagement/view/:id", name: "View Notification", Element: PatientNotificationForm,},
    {path: "/patient-engagement/duplicate/:id", name: "Duplicate Notification",Element: PatientNotificationForm,},
    { path: "/subscription-management", name: "Subscription Management", Element: SubscriptionManagementView },
    { path: "/subscription/success",    name: "Subscription Success", Element: SubscriptionSuccessView },
    {
  path: "/subscription-management/billing-profile",
  name: "Billing Profile",
  Element: BillingProfileView,
},
{
  path: "/subscription-management/edit-billing-profile",
  name: "Edit Billing Profile",
  Element: EditBillingProfileView,
},
{
  path: "/subscription-management/billing",
  name: "Billing Info",
  Element: SubscriptionBillingView,
},
  ]
export default AdminRoutes;
 
  
